<div
  [class]="
    'flex flex-col gap-(--snapshotcard-gap) px-(--snapshotcard-padding-x) py-(--snapshotcard-padding-y) rounded-(--snapshotcard-border-radius) bg-(--snapshotcard-color-background) font-(--snapshotcard-font-family) ' +
    (hasBorder() ? 'border border-(--snapshotcard-color-border)' : '')
  "
>
  @if (chipConfig() || canDismiss()) {
    <div class="flex items-center justify-between">
      @if (chipConfig()) {
        <app-dynamic
          [props]="{ config: chipConfig() }"
          componentName="Chip"
        />
      }
      @if (canDismiss()) {
        <app-dynamic
          (action)="onDismiss()"
          [props]="{ config: dismissButtonConfig() }"
          class="ml-auto"
          componentName="IconButton"
        />
      }
    </div>
  }

  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-2 gap-6">
      @for (snapshot of snapshotConfigs(); track $index; let isLast = $last) {
        @if (!isLast || snapshotConfigs().length % 2 === 0) {
          <div class="flex items-center gap-2">
            <app-dynamic
              componentName="SvgIcon"
              [props]="{ name: snapshot.icon, size: '32', color: 'var(--snapshotcard-icon-color)' }"
            />
            <div class="flex flex-col">
              <app-dynamic
                [props]="{ config: snapshot.labelConfig }"
                componentName="DynamicText"
              />
              <app-dynamic
                [props]="{ config: snapshot.valueConfig }"
                componentName="DynamicText"
              />
            </div>
          </div>
        }
      }
    </div>
    @if (lastSnapshotConfig(); as lastSnapshot) {
      <div class="flex items-center gap-2">
        <app-dynamic
          componentName="SvgIcon"
          [props]="{ name: lastSnapshot.icon, size: '32', color: 'var(--snapshotcard-icon-color)' }"
        />
        <div class="flex flex-col">
          <app-dynamic
            [props]="{ config: lastSnapshot.labelConfig }"
            componentName="DynamicText"
          />
          <app-dynamic
            [props]="{ config: lastSnapshot.valueConfig }"
            componentName="DynamicText"
          />
        </div>
      </div>
    }
  </div>

  @if (config().subtext) {
    <app-dynamic
      [props]="{ config: subtextConfig() }"
      componentName="DynamicText"
    />
  }

  @if (config().button) {
    <app-dynamic
      (action)="onButtonClick($event)"
      [props]="{ config: config().button }"
      componentName="Button"
    />
  }
</div>
